module.exports = __webpack_public_path__ + "static/media/studio-pro-icon.79f74129.svg";